import { RibbonError } from "@beds2b-group/reusable-components/dist/types";
import i18n from "../i18n/i18n";

// Códigos de error de disponibilidad que se pintan como aviso (amarillo); el resto, incluidos los desconocidos, como error (rojo)
const WARNING_ERROR_CODES: string[] = [
  "NoAvailabilityByMinimumStayRestriction",
  "NoAvailabilityByInvalidOccupancy",
];

/**
 * Ribbon para una habitación que viene con errorCode (roomAvailabilities[i].errorCode).
 * El texto sale de 'availability-errors.ribbon.<Code>' o, si el código no tiene traducción, de 'availability-errors.ribbon.default'.
 */
export function getRoomErrorRibbon(errorCode: string): RibbonError {
  const isWarning = WARNING_ERROR_CODES.includes(errorCode);

  return {
    code: errorCode,
    translation: i18n.t([`availability-errors.ribbon.${errorCode}`, "availability-errors.ribbon.default"]),
    classes: [isWarning ? "ribbon-warning" : "ribbon-error"],
    type: isWarning ? "warning" : "error",
  };
}

/**
 * Mensaje de página (NoData) para un errorCode a nivel de hotel (hotelAvailabilities[i].errorCode).
 * Si el código no tiene traducción se usa el mensaje genérico de "no hay disponibilidad".
 */
export function getHotelErrorMessage(errorCode: string): string {
  return i18n.t([`availability-errors.page.${errorCode}`, "pages.bookings-page.no-availability.description"]);
}
